import { createFileRoute, useRouter } from "@tanstack/react-router"
import { PageContent } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { ConfigurationForm } from "./-components/configuration-form"
import { PlaybookBar } from "./-components/playbook-bar"
import { usePlaybook } from "./-lib/playbook"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/playbooks/$playbookId/configuration",
)({
  component: ConfigurationPage,
})

function ConfigurationPage(): React.ReactElement {
  const { playbookId } = Route.useParams()
  const { playbook } = usePlaybook(playbookId)
  const showToast = useCustomToast()
  const router = useRouter()

  return (
    <div>
      <PlaybookBar playbookId={playbookId} />
      <PageContent>
        <ConfigurationForm
          key={playbook.id}
          playbook={playbook}
          onSave={({ name, retargeted }) => {
            if (!retargeted) {
              showToast("Saved", `${name} saved.`, "success")
            }
            return router.invalidate()
          }}
        />
      </PageContent>
    </div>
  )
}
